module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"role-help-info":"Explore as diferenças entre os perfis de acesso em nossa FAQ.","about-more":"Saiba mais."},"en-US":{"role-help-info":"Explore the differences between access profiles in our FAQ.","about-more":"Learn more."}}')
  delete Component.options._Ctor
}
